import React from "react";
import CustomInput from "../../../../../components/CustomInput";
import QuantityInput from "../../../../../components/QuantityInput";

const SERVICE_GRID = "grid-cols-[2.5fr_1.5fr_1.5fr_1.5fr]";

export const EditableTierRow = ({
  tier,
  tierIndex,
  serviceName,
  onUpdateTier,
  isFirstTier = false,
}) => {
  const subtotal = Number(tier.price || 0) * Number(tier.quantity || 1);

  let maxQtyPerTier = null;
  if (tierIndex > 0 && tier.maxQty && tier.minQty) {
    maxQtyPerTier = Number(tier.maxQty) - Number(tier.minQty) + 1;
  }

  return (
    <div
      className={`px-4 py-3 grid ${SERVICE_GRID} gap-2 items-center text-sm ${
        isFirstTier ? "border-b" : "border-t border-gray-100 bg-blue-50/30"
      }`}
    >
      <div>
        <CustomInput
          value={tier.rangeName || ""}
          onChange={(val) => onUpdateTier(tierIndex, { ...tier, rangeName: val })}
          placeholder="Nhập tên dịch vụ"
          height="36px"
        />
      </div>

      <div>
        <CustomInput
          type="number"
          value={tier.price}
          onChange={(val) => onUpdateTier(tierIndex, { ...tier, price: Number(val) || 0 })}
          placeholder="0"
          height="36px"
        />
      </div>

      <div className="flex items-center justify-center gap-2">
        {isFirstTier ? (
          <div className="w-[70px] h-9 border rounded-md flex items-center justify-center bg-gray-100 text-gray-600">
            1
          </div>
        ) : (
          <QuantityInput
            value={tier.quantity}
            onChange={(val) => onUpdateTier(tierIndex, { ...tier, quantity: val })}
            min={1}
            max={maxQtyPerTier}
            width="70px"
            height="36px"
          />
        )}
      </div>

      <div className="text-right font-semibold">
        <span className={isFirstTier ? "text-gray-800" : "text-blue-600"}>
          {subtotal?.toLocaleString() || 0} ₫
        </span>
      </div>
    </div>
  );
};

export const SimpleServiceRow = ({ serviceName, unitPrice, quantity, onUpdate }) => {
  const subtotal = Number(unitPrice || 0) * Number(quantity || 1);

  return (
    <div className={`px-4 py-3 grid ${SERVICE_GRID} gap-2 items-center text-sm border-b`}>
      <div>
        <span className="font-medium">{serviceName}</span>
      </div>
      <div className="text-right">
        <span>{Number(unitPrice).toLocaleString() || 0} ₫</span>
      </div>
      <div className="flex items-center justify-center">
        <QuantityInput
          value={quantity}
          onChange={(val) => onUpdate({ quantity: val })}
          min={1}
          width="70px"
          height="36px"
        />
      </div>
      <div className="text-right font-semibold">
        <span className="text-blue-600">
          {subtotal.toLocaleString() || 0} ₫
        </span>
      </div>
    </div>
  );
};
